module.exports = __webpack_public_path__ + "static/media/upcover.00d153c2.png";